/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      username
      email
      area
      ageGroup
      photo
      personalityScores
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        username
        email
        area
        ageGroup
        photo
        personalityScores
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMessageRequest = /* GraphQL */ `
  query GetMessageRequest($id: ID!) {
    getMessageRequest(id: $id) {
      id
      requesterID
      recipientID
      status
      message
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listMessageRequests = /* GraphQL */ `
  query ListMessageRequests(
    $filter: ModelMessageRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMessageRequests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        requesterID
        recipientID
        status
        message
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listChats = /* GraphQL */ `
  query ListChats(
    $filter: ModelChatFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChats(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        participants
        lastMessage
        lastMessageTime
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listTravelGroups = /* GraphQL */ `
  query ListTravelGroups(
    $filter: ModelTravelGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTravelGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        destination
        startDate
        endDate
        maxParticipants
        currentParticipants
        creatorID
        status
        tags
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listArticles = /* GraphQL */ `
  query ListArticles(
    $filter: ModelArticleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listArticles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        content
        authorID
        category
        tags
        featuredImage
        published
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
